export default __webpack_public_path__ + "static/media/sports-rebate-ico.94e15570.svg";